import React, { FC } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

export const VisibilityEyeIcon: FC<SVGComponentProps> = ({
  width = 16,
  height = 16,
  fill = '#ffffff'
}) => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <g
        clipPath="url(#a)"
        stroke={fill}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M1.613 8.476c-.09-.144-.136-.216-.161-.326a.8.8 0 0 1 0-.298c.025-.111.07-.183.161-.327C2.363 6.337 4.597 3.334 8 3.334c3.404 0 5.637 3.003 6.387 4.191.09.144.136.216.162.327a.8.8 0 0 1 0 .298c-.026.11-.071.182-.162.326-.75 1.188-2.983 4.191-6.387 4.191s-5.636-3.003-6.387-4.19" />
        <path d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill={fill} d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);
